import Schema from "AppReact/schema";
import { array } from 'AppReact/schema';

export default {
  credentials: Schema(array, "object", { defaultValue: [{name: '', value: ''}] })
};
